import { PcApiResponse } from '@/api/pc-api/types';
import { CiPermission } from '@/constants/svc';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type SvcName = {
  id: string;
  name: string;
  ciPermission: CiPermission;
};

export type SvcListName = {
  companyName: string;
  partnerId: string;
  svcNames: SvcName[];
};

export const getSvcListName = (partnerId: string) => {
  return api<PcApiResponse<SvcListName>>('get', `/pc-api/v1/${PREFIX_PATH}/svc/list/name`, { partnerId });
};
